import styled from "styled-components";
import { colors } from "../../../../../../../consts";
import { Paragraph2, TextButton, WrapperContainer } from "../../../../../../../components";

export const AddSummaryButton = styled(TextButton)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const SummaryTitleContainer = styled(WrapperContainer)`
  svg {
    path {
      transition: fill 0.3s;
    }
  }
`;

export const Title = styled(Paragraph2)`
  font-weight: 600;

  color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_100)};
`;
